import React, { useContext } from 'react';

const UserContext = React.createContext();

const userData = { current: {} };

export const getUserData = () => ({ ...userData.current });

export const setUserData = (data, key) => {
  // console.log('==> POS 10', data, key);

  if (key) {
    userData.current[key] = data;
  } else {
    userData.current = { ...data };
  }
};

const UserProvider = ({ children }) => {
  // const userData = useRef({});

  // const getUserData = () => ({ ...userData.current });

  const clearUserData = () => {
    userData.current = {};
  };

  // const getTokenCredentials = () => (
  //   tokenCredential.current && { ...tokenCredential.current }
  // );

  // const setTokenCredentials = (token) => { tokenCredential.current = { ...token }; };

  // const clearTokenCredentials = () => { tokenCredential.current = null; };

  const value = {
    setUserData,
    getUserData,
    clearUserData,
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserData = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useCount must be used within a UserProvider');
  }
  return context;
};

export default UserProvider;
